module.exports = __webpack_public_path__ + "static/media/heroimage_igib-025.3572b0fe.jpg";